/**
 * Mobile Navigation Module
 * Handles hamburger menu toggle and interactions
 */

export function initMobileNav(): void {
  const toggle = document.querySelector<HTMLButtonElement>('.nav__toggle');
  const navList = document.querySelector<HTMLElement>('.nav__list');

  if (!toggle || !navList) return;

  toggle.addEventListener('click', () => {
    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!isExpanded));
    navList.classList.toggle('is-open');

    // Toggle hamburger animation
    toggle.classList.toggle('is-active');
  });

  // Close menu when clicking outside
  document.addEventListener('click', (e: MouseEvent) => {
    const target = e.target as HTMLElement;
    if (!target.closest('.nav') && navList.classList.contains('is-open')) {
      navList.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.classList.remove('is-active');
    }
  });

  // Close menu on escape key
  document.addEventListener('keydown', (e: KeyboardEvent) => {
    if (e.key === 'Escape' && navList.classList.contains('is-open')) {
      navList.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.classList.remove('is-active');
      toggle.focus();
    }
  });
}
